export default function Hero() {
  return (
    <header className="hero" id="top">
      <div className="hero-grid" aria-hidden="true" />

      <div className="hero-badge">
        <span className="live" />
        <span className="hero-badge-text">
          Available for work
          <span className="hero-badge-sep" aria-hidden="true">
            &middot;
          </span>
          <span className="hero-badge-tags">
            UI &middot; Cloud &middot; IoT
          </span>
        </span>
      </div>

      <h1>
        Building software
        <br />
        for <span className="grad">web, mobile &amp; embedded.</span>
      </h1>

      <p className="lead">
        Full-stack and mobile work — commercial platforms, encrypted
        infrastructure, and iOS apps. Spanning marine IoT, desktop tools, and
        web.
      </p>

      <div className="hero-cta">
        <a className="btn btn-primary" href="#markour">
          View the work
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 12h14M13 6l6 6-6 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
        <a className="btn btn-ghost" href="#contact">
          Get in touch
        </a>
      </div>

      <div className="hero-stats">
        <div className="stat-chip">
          <b>iOS</b>
          <span>Native &amp; React Native</span>
        </div>
        <div className="stat-chip">
          <b>On-prem</b>
          <span>Self-hosted infra</span>
        </div>
        <div className="stat-chip">
          <b>Cloud</b>
          <span>Any</span>
        </div>
      </div>
    </header>
  );
}